import Cookies from 'js-cookie';
import React from 'react';
import { useLocation } from 'react-router';
import HeaderMfe from '|/app/header/header-mfe';
import PurchaseHeader from '|/app/header/purchase-header';
import { Summary } from '|/app/services';

const defaultProps = {
  orderSummary: null as null | Summary
};

function CarvanaHeader({ orderSummary } = defaultProps) {
  const { pathname } = useLocation();

  const hideHeader = Cookies.get('hide-header') === 'true' ? true : false;
  const shouldHideHeader =
    /CarvanaNativeWebView/gi.test(navigator?.userAgent) && hideHeader;

  const showPurchaseHeader =
    !pathname.startsWith('/steps/order-placed') &&
    !pathname.startsWith('/vehicle/');

  return (
    <>
      {showPurchaseHeader ? (
        <PurchaseHeader
          hideHeader={shouldHideHeader}
          orderSummary={orderSummary}
        />
      ) : (
        <HeaderMfe orderSummary={orderSummary} />
      )}
    </>
  );
}

export default CarvanaHeader;
